/**
 * Equipment configuration for Division 26 reusable components.
 */

import { formatDateUS } from './shared/dateUtils';

export const equipmentListConfig = {
  moduleName: 'Equipment',
  testIdPrefix: 'elec-equip',
  apiBase: '/electrical-equipment',
  columns: [
    { key: 'tag', label: 'Tag', cellClass: 'font-medium text-slate-900' },
    { key: 'equipmentType', label: 'Type', cellClass: 'text-slate-700' },
    { key: 'location', label: 'Location', cellClass: 'text-slate-700' },
    {
      key: 'ratingValue',
      label: 'Rating',
      render: (item) => item.ratingValue != null ? `${item.ratingValue} ${item.ratingUnit || ''}` : '-',
    },
    { key: 'manufacturer', label: 'Manufacturer', cellClass: 'text-slate-700' },
    { key: 'brandModel', label: 'Brand / Model', cellClass: 'text-slate-700' },
    {
      key: 'installDate',
      label: 'Installation Date',
      render: (item) => formatDateUS(item.installDate),
    },
  ],
};

export const equipmentFormConfig = {
  moduleName: 'Equipment',
  testIdPrefix: 'elec-equip',
  fields: [
    { key: 'tag', label: 'Tag', type: 'text', required: true, placeholder: 'Enter tag (e.g. GEN-01)' },
    { key: 'installDate', label: 'Installation Date', type: 'date', required: false },
    { key: 'typeId', label: 'Type', type: 'manufacturer', required: true },
    { key: 'location', label: 'Location', type: 'location', required: true, placeholder: 'Select location' },
    { key: 'ratingValue', label: 'Rating', type: 'rating', required: true, unitKey: 'ratingUnit', unitOptions: ['kW', 'kVA', 'Amps'] },
    { key: 'manufacturer', label: 'Manufacturer', type: 'text', required: true, placeholder: 'Enter manufacturer' },
    { key: 'brandModel', label: 'Brand / Model', type: 'text', required: true, placeholder: 'Enter brand / model' },
    { key: 'serialNumber', label: 'Serial Number', type: 'text', required: false, placeholder: 'Enter serial number' },
  ],
};

export const equipmentReviewConfig = {
  moduleName: 'Equipment',
  testIdPrefix: 'elec-equip',
  apiBase: '/electrical-equipment',
  fields: [
    { key: 'tag', label: 'Tag', type: 'text' },
    { key: 'equipmentType', label: 'Type', type: 'text' },
    { key: 'location', label: 'Location', type: 'text' },
    { key: 'ratingValue', label: 'Rating', type: 'rating', unitKey: 'ratingUnit' },
    { key: 'manufacturer', label: 'Manufacturer', type: 'text' },
    { key: 'brandModel', label: 'Brand / Model', type: 'text' },
    { key: 'serialNumber', label: 'Serial Number', type: 'text' },
    { key: 'installDate', label: 'Installation Date', type: 'date' },
  ],
};

export const EQUIPMENT_DATA_TYPES = ['O&M', 'Warranty', 'Datasheet'];
